import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import { useActiveSessionId, useActiveSessionIsPaused } from "./useActiveSessionSlice";
import { useOnlineStatus } from "./useOnlineStatus";
import type { GetTasksResponse } from "../types";
export function useThisSessionTasks() {
  const $ = _c(9);
  const apiFetcher = useApiFetcher();
  const isOnline = useOnlineStatus();
  const isSessionActive = Boolean(useActiveSessionId());
  const isBreakTime = useActiveSessionIsPaused();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = QUERY_KEYS.tasks.focus();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== apiFetcher) {
    t1 = () => apiFetcher("/api/v1/tasks?page=1&limit=3&groupSlug=in-session");
    $[1] = apiFetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isSessionActive && !isBreakTime ? 60000 : 300000;
  const t3 = isSessionActive ? 60000 : 300000;
  const t4 = isSessionActive ? 60000 : 300000;
  let t5;
  if ($[3] !== isOnline || $[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      queryKey: t0,
      enabled: isOnline,
      queryFn: t1,
      refetchInterval: t2,
      refetchIntervalInBackground: false,
      staleTime: t3,
      gcTime: t4,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    };
    $[3] = isOnline;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return useQuery(t5);
}